import axios from '@/api'
import {API_URL_BASE} from "../../constants/config";

export default {
  fetchCoupons({ commit }, payload){
    return new Promise((resolve, reject) => {
      if(payload.page){
        commit('SET_CURRENT_PAGE', payload.page)
      }
      axios.get(API_URL_BASE+'/admin/coupons',{params:payload})
        .then((response) => {
          commit('SET_COUPONS', response.data)
          resolve(response.data.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  storeCoupon({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.post(API_URL_BASE+'/admin/coupons', payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  },
  getCoupon({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.get(API_URL_BASE+'/admin/coupons/'+payload.id)
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => { reject(error.response) })
    })
  },
  deleteCoupon({ commit }, payload){
    return new Promise((resolve, reject) => {
      axios.delete(API_URL_BASE+'/admin/coupons/'+payload.id)
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response) })
    })
  }
}
